import { Component, Inject, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

export interface DialogData {
  title: string;
  content: string;
  confirmLabel: string;
  rejectLabel: string;
}

@Component({
  selector: 'udf-dialog',
  templateUrl: './udf-dialog.component.html',
  styleUrls: ['./udf-dialog.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
  ],
})
export class UdfDialogComponent {
  //   constructor(public dialogRef: MatDialogRef<UdfDialogComponent>) {}
  constructor(
    public dialogRef: MatDialogRef<UdfDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  onCancelClick(): void {
    this.dialogRef.close();
  }
}
